export default __webpack_public_path__ + "media/alarm_bell.0fdb27a.mp3";